<template>
    <div class="team">
        <v-dialog content-class="white" persistent v-model="progressLoad" max-width="80px">
            <v-progress-circular :size="50" indeterminate color="blue"></v-progress-circular>
        </v-dialog>
        <Header active="Administrators" />
        <TopSection heading="Administrator" user="J K" :hideSearch=true />
         <v-dialog v-model="errorDialog" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon @click="$router.push('/administrators')" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">An error has occurred.</span>
            </div>
        </v-dialog>
        <v-dialog v-model="success" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon @click="$router.push('/administrators')" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">Administrator successfully {{userId ? deleted ? 'deleted' : 'edited' : 'created'}}</span>
            </div>
        </v-dialog>

        <v-form>
            <v-container class="pt-3" grid-list-lg>
                <v-layout row wrap>
                    <v-flex xs12 md8 xl6>
                        <v-layout v-if="userId" row wrap class="form-section">
                            <v-flex xs12 sm6>
                                <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                    <span class="pl-3 white--text subheading font-weight-bold">First Name</span>
                                </div>
                                <v-text-field
                                    data-vv-name="firstName"
                                    maxlength=100
                                    :counter="100"
                                    data-vv-delay="300"
                                    v-model="user.firstName"
                                    :error-messages="errors.collect('firstName')"
                                    solo
                                    flat
                                    height=66
                                    placeholder="First Name">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                    <span class="pl-3 white--text subheading font-weight-bold">Last Name</span>
                                </div>
                                <v-text-field data-vv-name="lastName"
                                    maxlength=100
                                    :counter="100"
                                    data-vv-delay="300"
                                    v-model="user.lastName"
                                    :error-messages="errors.collect('lastName')"
                                    solo
                                    flat
                                    height=66
                                    placeholder="Last Name">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="form-section">
                            <v-flex xs12>
                                <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                    <span class="pl-3 white--text subheading font-weight-bold">Email
                                        <span v-if="userId !== undefined && user.authMethod == 3">(locked)</span>
                                    </span>
                                </div>
                                <v-text-field data-vv-name="email"
                                    data-vv-delay="300"
                                    v-validate="'required|email'"
                                    v-model="user.email"
                                    maxlength=100
                                    :counter="100"
                                    :error-messages="errors.collect('email')"
                                    onfocus="this.removeAttribute('readonly');" readonly
                                    solo
                                    flat
                                    height=66
                                    v-bind:disabled="userId !== undefined && user.authMethod == 3"
                                    placeholder="Email Address">
                                </v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap class="form-section">
                            <v-flex xs12>
                                <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                    <span class="pl-3 white--text subheading font-weight-bold">Authentication method</span>
                                </div>
                                <v-radio-group
                                    v-model="user.authMethod"
                                    column
                                >
                                    <div class="standard-height mb-1__custom white relative display-flex auth-method__checkbox">
                                        <v-radio
                                            label="Single Sign On (SSO)"
                                            color="blue"
                                            value="3"
                                        ></v-radio>
                                    </div>
                                    <div class="standard-height mb-1__custom white relative display-flex auth-method__checkbox">
                                        <v-radio
                                            color="blue"
                                            value="1"
                                        >
                                            <template slot="label">
                                                <div class="html-label">
                                                    <span>Local User (Username and Password)</span>
                                                    <span class="label__info">Email Verification</span>
                                                </div>
                                            </template>
                                        </v-radio>
                                    </div>
                                    <div class="standard-height white relative display-flex auth-method__checkbox">
                                        <v-radio
                                            color="blue"
                                            value="2"
                                        >
                                            <template slot="label">
                                                <div class="html-label">
                                                    <span>Local User (Username and Password)</span>
                                                    <span class="label__info">Phone Number Verification</span>
                                                </div>
                                            </template>
                                        </v-radio>
                                    </div>
                                </v-radio-group>
                            </v-flex>
                        </v-layout>

                        <v-layout v-if="user.authMethod == '2'" row wrap class="form-section">
                            <v-flex xs12>
                                <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                    <span class="pl-3 white--text subheading font-weight-bold">Enter Phone Number (including international dialing code)</span>
                                </div>
                                <v-text-field data-vv-name="phoneNumber"
                                    :counter="100"
                                    data-vv-delay="300"
                                    v-validate="'required|phoneNumber'"
                                    v-model="user.phoneNumber"
                                    :error-messages="errors.collect('phoneNumber')"
                                    solo
                                    flat
                                    onfocus="this.removeAttribute('readonly');" readonly
                                    height=66>
                                </v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout v-if="userType == 1" row wrap class="form-section additional-access">
                            <v-flex xs12 class="py-0">
                                <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                    <span class="pl-3 white--text subheading font-weight-bold">Additional access</span>
                                </div>
                                <div class="px-4 standard-height mb-1__custom white relative display-flex ">
                                    <v-checkbox
                                        label="System Administrator"
                                        dark--text
                                        large
                                        class="large font-weight-bold cc__checkbox pl-3"
                                        v-model="user.isSysAdmin">
                                    </v-checkbox>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex xs12 sm5>
                                <v-btn @click="submit" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                    <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">{{userId ? 'Save changes' : 'Create Administrator'}}</span>
                                    <v-icon right class="white--text title">{{userId ? 'save' : 'add'}}</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm5>
                                <v-btn @click="$router.push('/administrators')" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                    <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Cancel</span>
                                </v-btn>
                            </v-flex>
                            <v-flex v-if="userId && currentUserId != userId" xs12 sm5>
                                <v-btn @click="dialog = true" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                    <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Delete</span>
                                    <v-icon right class="white--text title">delete</v-icon>
                                </v-btn>
                                 <v-dialog v-model="dialog" persistent max-width="520">
                                    <div class="notification-heading standard-height blue pr-4">
                                        <v-icon @click="$router.push('/administrators')" class="white body-2 blue--text notification-close mr-1">close</v-icon>
                                    </div>
                                    <v-card class="pt-4 pb-3">
                                        <v-card-title class="justify-center subtitle primary--text font-weight-bold">Do you really want to delete?</v-card-title>
                                        <v-card-actions>
                                            <v-btn class="white--text" color="grey lighten-1" grey @click="dialog = false">Cancel </v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn class="white--text" color="grey lighten-1" grey @click="submit('delete')">Confirm</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import TopSection from '../components/TopSection.vue'
    import Header from '../components/Header.vue'
    import router from '../router'
    import Vue from 'vue'
    import VeeValidate, { Validator } from 'vee-validate'
    import PhoneNumber from 'awesome-phonenumber'
    import simplebar from 'simplebar-vue'
    import 'simplebar/dist/simplebar.min.css'
    import administratorService from '../services/administrator'
    import userService from '../services/user'

    const phoneNumber = {
        getMessage: field => `Phone number is not valid`,
        validate (value) {
            let valueToCheck = value
            const internationalCode = '00';
            if ((valueToCheck.substring(0, 2) == internationalCode) && (valueToCheck.indexOf(internationalCode) == 0)) {
                valueToCheck = valueToCheck.replace('00', '+')
            }
            return new Promise(resolve => {
            let phone = new PhoneNumber(valueToCheck, 'international');
            resolve({ valid: phone.isValid() })
            })
        }
    }
    Validator.extend('phoneNumber', phoneNumber)

    Vue.use(VeeValidate);
    export default {
        name: 'App',
        components: {
            Header, TopSection, simplebar
        },
        $_veeValidate: {
            validator: 'new'
        },
        mounted() {
            this.$validator.localize('en', this.dictionary)
        },
        data() {
            return {
				userType: sessionStorage.userType,
                progressLoad: false,
                errorDialog: false,
                emailError: null,
                dialog: false,
                show: true,
                companyId: sessionStorage.companyId,
                currentUserId: sessionStorage.userId,
                success: false,
                deleted: false,
                disableEmail: false,
                userId: this.$route.params.id,
                user: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    isDisabled: false,
                    authMethod: '0',
                    phoneNumber: null,
                    isAdmin: false,
                    isSysAdmin: false,
                },
                dictionary: {
                    custom: {
                        firstName: {
                            required: () => 'First name is required'
                        },
                        lastName: {
                            required: () => 'Last name is required'
                        },
                        email: {
                            required: () => 'Email is required'
                        },
                        phoneNumber: {
                            required: () => 'Phone number is required'
                        },
                    }
                },
            }
        },
        methods: {
            async fetchData() {
                if (this.userId) {
                    this.disableEmail = true;
                    this.userData = await administratorService.fetchById(this.userId);
                    this.userData = this.userData.data;
                    this.user.firstName = this.userData.firstName;
                    this.user.lastName = this.userData.surname;
                    this.user.isDisabled = this.userData.isDisabled;
                    this.user.email = this.userData.email;
                    this.user.phoneNumber = this.userData.phoneNumber;
                    this.user.isAdmin = this.userData.isAdmin;
                    this.user.isSysAdmin = this.userData.isSysAdmin;
                    this.user.authMethod = this.userData.permittedLoginType.toString()
                } else {
                    const getDefaultAuthenticationType = await userService.getDefaultAuthenticationType(this.companyId);
                    this.user.authMethod = getDefaultAuthenticationType.data == 1 ? '3' : '1';
                }
            },
            homeRedirect() {
                router.push('/administrators')
            },
            submit(e) {
                if (e == 'delete') {
                    this.dialog = false;
                    this.progressLoad = true;
                    administratorService.delete(this.userId)
                        .then(res => {
                            this.progressLoad = false;
                            if (res.data.status == 1) {
                                this.success = true;
                                this.deleted = true;
                            }
                        }).catch(err => {
                            this.progressLoad = false;
                            this.errorDialog = true;
                        });
                } else {
                    this.$validator.validate().then(result => {
                        if (result) {
                            this.progressLoad = true;
                            if (this.userId) {
                                var dataUpdate = {};

                                if (this.user.firstName != this.userData.firstName) {
                                    dataUpdate['firstName'] = this.user.firstName;
                                }
                                if (this.user.lastName != this.userData.lastName) {
                                    dataUpdate['surname'] = this.user.lastName;
                                }
                                if (this.user.email != this.userData.email) {
                                    dataUpdate['email'] = this.user.email;
                                }
                                if (this.user.isDisabled != this.userData.isDisabled) {
                                    dataUpdate['isDisabled'] = this.user.isDisabled;
                                }
                                if(this.user.phoneNumber != this.userData.phoneNumber) {
                                    dataUpdate[ 'phoneNumber'] = this.user.phoneNumber;
                                }

                                if(this.user.isSysAdmin != this.userData.isSysAdmin) {
                                    dataUpdate[ 'IsSysAdmin'] = this.user.isSysAdmin;
                                }

                                if(parseFloat(this.user.authMethod) != this.userData.permittedLoginType) {
                                    dataUpdate['permittedLoginType'] = parseFloat(this.user.authMethod);
                                }
                                administratorService.update(this.userId, dataUpdate)
                                .then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                    } else {
                                        this.success = false;
                                    }
                                    }).catch(err => {
                                        this.progressLoad = false;
                                        this.$validator.errors.add({field : error.data.data[0].errorField, msg : error.data.data[0].errorMessage})
                                        if( error.status == 500){
                                            this.errorDialog = true;
                                        }
                                    });
                            } else {
                                administratorService.create({
                                    "userType": 2,
                                    'email': this.user.email,
                                    'companyId': this.companyId,
                                    'phoneNumber': this.user.phoneNumber,
                                    'permittedLoginType': parseFloat(this.user.authMethod),
                                    'isAdmin': true,
                                    'isSysAdmin': this.user.isSysAdmin
                                }).then(res => {
                                    this.progressLoad = false;
                                        if (res.data.status == 1) {
                                            this.success = true;
                                        } else {
                                            this.success = false;
                                        }
                                }).catch(error => {
                                    this.progressLoad = false;
                                    this.$validator.errors.add({field : error.data.data[0].errorField, msg : error.data.data[0].errorMessage})
                                     if( error.status == 500){
                                            this.errorDialog = true;
                                    }
                                });
                            }
                        }
                    });

                }
            }
        },
        created() {
            this.fetchData();
        }
    }

</script>

<style lang="scss">
    .additional-access {

        .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
            margin-bottom: 0;
            justify-content: space-between;
        }

        .v-input__control {
            width: 100%;
        }

        .v-input--selection-controls__input {
            order: 2;
            margin-right: 0;
        }

        .v-input--selection-controls.v-input .v-label {
            order: 1;
            font-weight: 400;
            width: 100%;
        }

        .cc__checkbox:after {
            top: 24px;
            right: 20px;
            lefT: unset;
        }
    }
</style>

